import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/grainType',
    meta: { title: '粮油类型' },
    component: Layout,
    redirect: '/grainType/list',

    children: [
      {
        path: 'list',
        meta: { title: '粮油类型' },
        component: () => import('@/views/grainType/GrainType')
      },
      {
        path: 'add',
        meta: {
          title: '粮油类型新增',
          activeMenu: '/grainType'
        },
        component: () => import('@/views/grainType/GrainTypeAdd')

      },
      {
        path: 'edit',
        meta: {
          title: '粮油类型编辑',
          activeMenu: '/grainType'
        },
        component: () => import('@/views/grainType/GrainTypeAdd')

      },
      {
        path: 'detail',
        meta: {
          title: '粮油类型详情',
          activeMenu: '/grainType'
        },
        component: () => import('@/views/grainType/GrainTypeDetail')

      }

    ]
  }
]
